import { PaymentRequestStatus } from './AppConstants'

export const canBeUploadFiles = (paymentRequest) => {
    if (paymentRequest === null || paymentRequest === undefined)
        return false
    if (paymentRequest.Status !== PaymentRequestStatus.CLOSED)
        return true
    return false
}